import React from 'react'
import ViewResource from './fileupload/viewCoursecommon'

const Studymaterialview=()=>{
  return(
    <>
    <ViewResource type="Resource" plural="resources" sponsorStudies={true}/>
    </>
  )
}
export default Studymaterialview